module.exports = __webpack_public_path__ + "static/media/download_app_icon.22ac8d66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/coolRide/images/download_app_icon.svg
// module id = 574
// module chunks = 0